module.exports = __webpack_public_path__ + "img/product_103.ab5ea71.webp";